import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RoundPipe } from './round.pipe';
@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [RoundPipe],
  providers: [],
  exports: [RoundPipe]
})

export class RoundPipeModule {

}
